import { BrowserRouter } from "react-router-dom";
import { StoreProvider } from "./store";
import AppRoutes from "./routes";
import { BDSProvider } from '@barracuda-internal/bds-core';

function App() {
  return (
    <BDSProvider useBdsTheme={true}>
        <StoreProvider>
        <BrowserRouter>
            <AppRoutes />
        </BrowserRouter>
        </StoreProvider>
    </BDSProvider>
  );
}

export default App;
